import lcvRoutesManifest from "./lcvRoutes.manifest.json";
import { LCV_ROUTE_CITIES } from "./lcvRouteCities";
import { getVerifiedHreflangLocales } from "./lcvRouteLocaleSlugs";
import { LcvRouteConfig } from "./types";

type LcvRouteCityKey = keyof typeof LCV_ROUTE_CITIES;

type LcvRouteManifestEntry = {
    slug: string;
    source: LcvRouteCityKey;
    destination: LcvRouteCityKey;
    hreflangLocales: string[];
};

const defineRoute = (
    slug: string,
    source: LcvRouteCityKey,
    destination: LcvRouteCityKey,
    hreflangLocales: string[]
): LcvRouteConfig => ({
    slug,
    hreflangLocales,
    source: LCV_ROUTE_CITIES[source],
    destination: LCV_ROUTE_CITIES[destination]
});

/** Route list — edit lcvRoutes.manifest.json only (also used by sitemap generator). */
export const LCV_ROUTES: LcvRouteConfig[] = (lcvRoutesManifest as LcvRouteManifestEntry[]).map(
    ({ slug, source, destination, hreflangLocales }) =>
        defineRoute(slug, source, destination, getVerifiedHreflangLocales(slug, hreflangLocales))
);

export const lcvRoutesBySlug = Object.fromEntries(LCV_ROUTES.map((route) => [route.slug, route])) as Record<
    string,
    LcvRouteConfig
>;
